export const CRAFTS = [
  'Actor',
  'Director',
  'DOP / Cinematographer',
  'Editor',
  'Writer / Screenwriter',
  'Music Composer',
  'Background Score',
  'Sound Designer',
  'Sound Mixer',
  'Production Designer',
  'Art Director',
  'Costume Designer',
  'Makeup Artist',
  'VFX Artist',
  'Motion Graphics',
  'Colorist',
  'Stunt Coordinator',
  'Producer',
  'Executive Producer',
  'Line Producer',
  'Assistant Director',
  'Casting Director',
  'Choreographer',
  'Singer',
  'Lyricist',
  'Dubbing Artist',
  'Voice Over Artist',
  'Camera Assistant',
  'Gaffer',
  'Boom Operator',
  'Script Supervisor',
  'Still Photographer',
  'Background Artist',
  'Junior Artist',
  'Other',
]

export const CONTENT_TYPES = [
  'ALL',
  'Short Film',
  'Feature Film',
  'Web Series',
  'Ad Film / TVC',
  'Documentary',
  'Music Video',
  'TV Show',
  'Original Series (OTT)',
  'Reality Show',
  'Talk Show',
  'News / Journalism',
  'Animation',
  'Corporate Film',
  'Social Media Content',
  'Podcast / Audio',
  'Stage / Theatre',
  'Live Event',
  'Other',
]

export const LANGUAGES = [
  'English',
  'Telugu',
  'Hindi',
  'Tamil',
  'Kannada',
  'Malayalam',
  'Bengali',
  'Marathi',
  'Punjabi',
  'Gujarati',
  'Odia',
  'Assamese',
  'Arabic',
  'French',
  'Spanish',
  'Portuguese',
  'Mandarin',
  'Japanese',
  'Korean',
  'German',
  'Italian',
  'Bahasa Indonesia',
  'Malay',
  'Bilingual',
  'Multilingual',
  'Other',
]

export const LOCATION_DATA = {
  India: {
    'Any State': ['Any City'],
    'Andhra Pradesh': [
      'Any City',
      'Visakhapatnam',
      'Vijayawada',
      'Guntur',
      'Tirupati',
      'Rajahmundry',
      'Nellore',
      'Kakinada',
      'Eluru',
      'Kurnool',
    ],
    Telangana: [
      'Any City',
      'Hyderabad',
      'Warangal',
      'Karimnagar',
      'Nizamabad',
      'Khammam',
      'Nalgonda',
      'Mahbubnagar',
    ],
    'Tamil Nadu': [
      'Any City',
      'Chennai',
      'Coimbatore',
      'Madurai',
      'Trichy',
      'Salem',
      'Tirunelveli',
      'Vellore',
      'Erode',
    ],
    Karnataka: [
      'Any City',
      'Bangalore',
      'Mysore',
      'Mangalore',
      'Hubli',
      'Dharwad',
      'Belagavi',
      'Davangere',
      'Shimoga',
    ],
    Maharashtra: [
      'Any City',
      'Mumbai',
      'Pune',
      'Nagpur',
      'Nashik',
      'Aurangabad',
      'Solapur',
      'Kolhapur',
      'Thane',
    ],
    Delhi: ['Any City', 'New Delhi', 'Noida', 'Gurgaon', 'Faridabad', 'Ghaziabad'],
    'West Bengal': ['Any City', 'Kolkata', 'Siliguri', 'Durgapur', 'Howrah', 'Asansol'],
    Kerala: [
      'Any City',
      'Kochi',
      'Thiruvananthapuram',
      'Kozhikode',
      'Thrissur',
      'Kannur',
      'Kottayam',
      'Alappuzha',
    ],
    Punjab: ['Any City', 'Chandigarh', 'Amritsar', 'Ludhiana', 'Jalandhar', 'Patiala'],
    Rajasthan: ['Any City', 'Jaipur', 'Jodhpur', 'Udaipur', 'Kota', 'Ajmer'],
    Gujarat: ['Any City', 'Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Gandhinagar'],
    'Madhya Pradesh': ['Any City', 'Bhopal', 'Indore', 'Gwalior', 'Jabalpur', 'Ujjain'],
    'Uttar Pradesh': [
      'Any City',
      'Lucknow',
      'Varanasi',
      'Agra',
      'Kanpur',
      'Allahabad',
      'Meerut',
    ],
    Bihar: ['Any City', 'Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur'],
    Odisha: ['Any City', 'Bhubaneswar', 'Cuttack', 'Puri', 'Rourkela'],
    Assam: ['Any City', 'Guwahati', 'Dibrugarh', 'Silchar', 'Jorhat'],
    Goa: ['Any City', 'Panaji', 'Margao', 'Mapusa'],
    'Himachal Pradesh': ['Any City', 'Shimla', 'Manali', 'Dharamsala'],
    'Jammu & Kashmir': ['Any City', 'Srinagar', 'Jammu', 'Leh'],
    Uttarakhand: ['Any City', 'Dehradun', 'Haridwar', 'Rishikesh', 'Nainital'],
    Jharkhand: ['Any City', 'Ranchi', 'Jamshedpur', 'Dhanbad'],
    Chhattisgarh: ['Any City', 'Raipur', 'Bilaspur', 'Durg'],
  },
  USA: {
    'Any State': ['Any City'],
    California: [
      'Any City',
      'Los Angeles',
      'San Francisco',
      'San Diego',
      'Sacramento',
      'Oakland',
      'Fresno',
    ],
    'New York': ['Any City', 'New York City', 'Buffalo', 'Albany', 'Rochester'],
    Texas: ['Any City', 'Austin', 'Houston', 'Dallas', 'San Antonio'],
    Florida: ['Any City', 'Miami', 'Orlando', 'Tampa', 'Jacksonville'],
    Georgia: ['Any City', 'Atlanta', 'Savannah'],
    Illinois: ['Any City', 'Chicago'],
    Washington: ['Any City', 'Seattle', 'Tacoma'],
    Nevada: ['Any City', 'Las Vegas', 'Reno'],
  },
  UK: {
    'Any State': ['Any City'],
    England: [
      'Any City',
      'London',
      'Manchester',
      'Birmingham',
      'Liverpool',
      'Bristol',
      'Leeds',
      'Sheffield',
    ],
    Scotland: ['Any City', 'Edinburgh', 'Glasgow', 'Aberdeen'],
    Wales: ['Any City', 'Cardiff', 'Swansea'],
    'Northern Ireland': ['Any City', 'Belfast'],
  },
  Australia: {
    'Any State': ['Any City'],
    'New South Wales': ['Any City', 'Sydney', 'Newcastle', 'Wollongong'],
    Victoria: ['Any City', 'Melbourne', 'Geelong', 'Ballarat'],
    Queensland: ['Any City', 'Brisbane', 'Gold Coast', 'Sunshine Coast'],
    'Western Australia': ['Any City', 'Perth', 'Fremantle'],
    'South Australia': ['Any City', 'Adelaide'],
  },
  Canada: {
    'Any State': ['Any City'],
    Ontario: ['Any City', 'Toronto', 'Ottawa', 'Hamilton', 'London'],
    'British Columbia': ['Any City', 'Vancouver', 'Victoria', 'Kelowna'],
    Quebec: ['Any City', 'Montreal', 'Quebec City'],
    Alberta: ['Any City', 'Calgary', 'Edmonton'],
  },
  UAE: {
    'Any State': ['Any City'],
    Dubai: ['Any City', 'Dubai', 'Deira', 'Bur Dubai', 'JLT'],
    'Abu Dhabi': ['Any City', 'Abu Dhabi', 'Al Ain'],
    Sharjah: ['Any City', 'Sharjah'],
    Ajman: ['Any City', 'Ajman'],
  },
  'Saudi Arabia': {
    'Any State': ['Any City'],
    'Riyadh Region': ['Any City', 'Riyadh'],
    'Makkah Region': ['Any City', 'Jeddah', 'Mecca', 'Taif'],
    'Eastern Province': ['Any City', 'Dammam', 'Al Khobar'],
  },
  Singapore: { Singapore: ['Any City', 'Singapore', 'Orchard', 'Marina Bay'] },
  Other: { 'Any Region': ['Any City'] },
}

export const PRODUCER_TIP_TEXT =
  'Producers are the hardest to find on any platform — their posts are rare. If no producer posts appear below, go to PitchBlu profile search, filter by "Producer" and reach out directly with your pitch. Also remember: budget does not always need one big producer — two or three smaller investors doing a combined production often works faster and better.'
